module.exports = __webpack_public_path__ + "img/map-example.7a86a7b.webp";